const isHashExpired = (expMs: number): boolean => {
	const nowMs = Date.now()
	return  nowMs > expMs
}

export default isHashExpired
